import axios from 'axios'
import { setCSRFToken, checkResponseStatus } from './interceptors'

const axiosInstance = axios.create({
  timeout: 30000,
  headers: {
    Accept: 'application/json'
  }
})

setCSRFToken(axiosInstance)
checkResponseStatus(axiosInstance)

export default axiosInstance